import React from 'react'
import Header from '../inc/Header'
import AddCareer from '../AddCareer'
import ScrollToTop from "react-scroll-to-top";
import {Link} from "react-router-dom";


function Careerpage() {
  return (
    <div>
        <Header/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
   
        <ScrollToTop smooth top="100" color="grey"/>
      <div className='newback'>
        <div className="album py-1">

          <div className="container mt-3">

            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Career</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <br/>
        <AddCareer/>
        <br/>
    </div>
  )
}

export default Careerpage